var next = __webpack_require__.x
__webpack_require__.x = function() {
  return __webpack_require__.e("webpack_sharing_provide_default_lingui_react-webpack_sharing_provide_default_tanstack_react-q-2f458b").then(next);
}